// extracted by mini-css-extract-plugin
export default {"root":"LoginModal_root__XENGj","submit":"LoginModal_submit__ebWCV","close":"LoginModal_close__LMW-E","background":"LoginModal_background__u7mTe"};